/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = CheckIn
 *
 * 2 = CheckOut
 */
export enum LoanCarCheckActionType {
  CheckIn = 1,
  CheckOut = 2,
}
